<template>
  <div class="chart-container" style="position: relative; height:30%; width:98%">
    <canvas ref="chartEl" width="98%" height="30%">
      <p>Disk USB storage</p>
    </canvas>
  </div>
</template>
<script>
/* eslint-disable */
import Chart from 'chart.js';
import gql from 'graphql-tag';
import moment from 'moment';
import EventBus from '@/utils/EventBus';

const QUERY_DISK_USAGE = gql`
query query_disk_usage($id: String!, $startTime: timestamptz!, $endTime: timestamptz!) {
  disk_usage (
    where: {
      _and: [
        {
          device_id: {
            _eq: $id
          }
        },
        {
          timestamp: {
            _gt: $startTime
          }
        },
        {
          timestamp: {
            _lt: $endTime
          }
        }
      ]
    }
    order_by: {
      timestamp: asc
    }
  ) {
    timestamp
    ext_total_bytes
    ext_free_bytes
  }
}
`;
const SUBSCRIPTION_DISK_USAGE = gql`
subscription subscription_disk_usage($id: String!, $timestamp: timestamptz) {
  disk_usage (
    where: {
      device_id: {
        _eq: $id
      }
      timestamp:{
        _gt: $timestamp
      }
    }
    order_by: {
      timestamp: desc
    }
    limit: 1
  ) {
    timestamp
    ext_total_bytes
    ext_free_bytes
  }
}
`;

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    start: {
      type: String,
      required: true,
    },
    end: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      disks: [],
      chartUI: null,
      startTime: this.start,
      endTime: this.end,
      subscription: null,
      showNewValues: true,
    };
  },
  created() {
    EventBus.$on('monitoring-time-changed', this.reCreateChart);
  },
  beforeDestroy() {
    if (this.chartUI) {
      this.chartUI.destroy();
    }
    EventBus.$off('monitoring-time-changed', this.reCreateChart);
  },
  async mounted() {
    await this.getDisks();
    this.createChart();
    // subscribe to new cpu values
    this.subcribeNewDisks();
  },
  methods: {
    async reCreateChart(data) {
      this.startTime = data.startTime;
      this.endTime = data.endTime;
      // wait for battery values
      await this.getDisks();
      // create chartjs UI
      if (this.chartUI) {
        this.chartUI.destroy();
      }
      this.createChart();
      /*
      if (data.subscribe) {
        console.log('show new values');
      } else {
        this.stopSubscription();
      }
      */
    },
    stopSubscription() {
      console.log('Don\'t show new values');
    },
    async getDisks() {
      const result = await this.$apollo.query({
        query: QUERY_DISK_USAGE,
        variables: {
          id: this.id,
          startTime: this.startTime,
          endTime: this.endTime,
        },
      });

      // create values for chartjs
      this.disks = result.data.disk_usage.map((disk) => ({
        timestamp: new Date(disk.timestamp),
        disks: [disk.usb_total_bytes/1000000, disk.usb_free_bytes/1000000]
      }));
    },
    createChart() {
      // create chartjs UI
      const config = {
        type: 'line',
        data: {
          datasets: []
        },
        options: {
          title: {
					  display: true,
					  text: 'USB (MB)'
				  },
          responsive: true,
          scales: {
            xAxes: [{
              gridLines: {
                color: 'rgba(150, 150, 150, 0.5)'
              },
              type: 'time',
              display: true,
              time: {
                tooltipFormat: 'YYYY-MM-DD HH:mm',
                displayFormats: {
                    millisecond: 'HH:mm:ss.SSS',
                    second: 'HH:mm:ss',
                    minute: 'HH:mm',
                    hour: 'HH'
                },
                unit: 'minute',
                stepSize: 30,
              },
            }],
            yAxes: [{
              gridLines: {
                color: 'rgba(150, 150, 150, 0.5)'
              },
              display: true,
              ticks: {
                beginAtZero: true,
              }
            }]
          }
        }
      };
      const colors = [
        'red',
        'blue',
        'green',
        'cyan',
        'orange',
        'magenta',
        'purple',
        'black'
      ];
      const labels = [
        'Total',
        'Free',
      ];
      // Create datasets
      for (let step = 0; step < 2; step++) {
        config.data.datasets.push({
          label: labels[step],
          borderColor: colors[step],
          backgroundColor: colors[step],
          fill: false,
          data: [],
        });
      }

      // Push value based on array index to correct dataset
      this.disks.forEach((temp) => {
        const { timestamp } = temp;
        const date = new Date(timestamp);
        if (temp.disks) {
          temp.disks.forEach((tmp, tmpIndex) => {
            const value = {
              x: date,
              y: tmp,
            };

            config.data.datasets[tmpIndex].data.push(value);
          });
        }
      });

      const { chartEl } = this.$refs;
      this.chartUI = new Chart(chartEl, config);
    },
    subcribeNewDisks() {
      const { id } = this;
      const that = this;
      const timestamp = new Date().toISOString();

      // start subscribing to new cpu values
      this.$apollo.subscribe({
        query: SUBSCRIPTION_DISK_USAGE,
        variables: {
          id,
          timestamp
        },
      }).subscribe({
          next(data) {
            // got new subscription result
            if (data.data.disk_usage.length > 0) {
              // Add new cpu value to chart
              const [temp] = data.data.disk_usage;
              const val = {
                timestamp: temp.timestamp,
                disks: [temp.usb_total_bytes, temp.usb_free_bytes]
              };
              that.disks.push(val);
              that.addData(val);
            }
          },
          error(err) { console.error('err', err); },
      });
    },
    addData(data) {
      // create new value for chartjs
      for (let step = 0; step < 2; step++) {
        const value = {
        x: new Date(data.timestamp),
        y: data.disks[step],
      };
        this.chartUI.data.datasets[step].data.push(value);
      }

      // Update chartjs UI
      this.chartUI.update();
    },
  },
};
</script>
<style scoped>
</style>
